// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Kv2x","select":"styles_select__1-okx"};